var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterMedia({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_15538_141)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconly Two-tone Play"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Play-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1-61",
    d: "M12.9998 0.906982C15.3915 0.906982 17.7296 1.61622 19.7183 2.94502C21.707 4.27382 23.257 6.16241 24.1723 8.37212C25.0876 10.5818 25.327 13.0135 24.8604 15.3593C24.3938 17.7051 23.2421 19.8598 21.5508 21.551C19.8596 23.2423 17.7048 24.3941 15.359 24.8607C13.0132 25.3273 10.5817 25.0878 8.37195 24.1725C6.16224 23.2572 4.27358 21.7072 2.94478 19.7185C1.61598 17.7298 0.906738 15.3918 0.906738 13C0.906738 9.79274 2.18081 6.71686 4.44869 4.44897C6.71658 2.18109 9.79249 0.906982 12.9998 0.906982V0.906982Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3-55",
    d: "M16.6883 13.5683C15.3502 14.8163 13.8291 15.8522 12.1776 16.64C11.9207 16.7539 11.6534 16.843 11.3795 16.906C11.2659 16.9069 11.1542 16.877 11.0563 16.8195C10.9583 16.762 10.8778 16.6791 10.8232 16.5795C10.7376 16.3058 10.669 16.0272 10.6176 15.7451C10.4949 14.7827 10.4384 13.813 10.4483 12.8428C10.4336 11.8355 10.4983 10.8287 10.6418 9.83164C10.6418 9.65025 10.7748 9.21481 10.799 9.14226C10.8582 9.01511 10.9554 8.90948 11.0772 8.83993C11.1701 8.79032 11.2742 8.76542 11.3795 8.76745C11.6161 8.81607 11.8471 8.88893 12.0688 8.98504C13.7582 9.77269 15.3131 10.8216 16.6762 12.093L17.0269 12.4678C17.1036 12.5733 17.1449 12.7003 17.1449 12.8307C17.1449 12.961 17.1036 13.0881 17.0269 13.1935L16.6883 13.5683Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15538_141"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterMedia);
export default __webpack_public_path__ + "static/media/footer_media.8502b9f86cdd8d7fab336e2ba388db22.svg";
export { ForwardRef as ReactComponent };